'use client';
/** @jsxImportSource @emotion/react */

import type { TableRowProps as MuiTableRowProps } from '@mui/material/TableRow';

import MuiTableRow from '@mui/material/TableRow';

type ExcludedMuiProps = '';

interface TableRowProps extends Omit<MuiTableRowProps, ExcludedMuiProps> {
  component?: React.ElementType;
}

export type { TableRowProps };
export const TableRow: React.FC<TableRowProps> = MuiTableRow;

TableRow.displayName = 'TableRow';
